// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3GZgHdiZyWB7We3F7gPmKP","chipsWrapper":"_2SkJgcNeTZ3IapDRTk9SE9","additionalFiltersTitle":"_1KOc-1oxS2nCSOYGJGDXii"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePagePropertiesContainer/HomePagePropertiesContainer.scss
// module id = 1809
// module chunks = 0